import React from "react";
import "./SubjectChips.css";

const SelectedSubjects = ({ selectedSubjects, onRemove, onClearAll }) => {
  if (!selectedSubjects.length) return null;

  return (
    <div className="selected-subjects-box">
      <div className="selected-header">
        <h4 className="selected-heading">Added Lessons:</h4>
        <button className="clear-all-btn" onClick={onClearAll}>
          Clear All
        </button>
      </div>

      <div className="subject-tags">
        {selectedSubjects.map((subject, index) => (
          <div className="subject-tag" key={index}>
            {subject}
            <button
              className="remove-btn"
              onClick={() => onRemove(subject)}
              title="Remove"
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedSubjects;
